import React from "react";
import { XIcon } from "lucide-react";
import { problems } from "../data/content";
import { SectionTitle } from "./SectionTitle";
export function Problems() {
  return <section className="bg-mist px-4 py-16 sm:px-6 sm:py-24" data-id="element-141" data-mp="32516mb0zc1b8">
      <SectionTitle tone="light" title={<>Si vous enseignez la guitare, vous vivez sans doute <span className="text-golddark" data-id="element-143" data-mp="2y2xqva7a2ak5">au moins une de ces situations.</span></>} data-id="element-142" data-mp="323hr4mn5duai" />
      <ul className="mx-auto mt-10 grid max-w-5xl gap-4 sm:mt-14 sm:grid-cols-2" data-id="element-144" data-mp="2t55tw1rrzy93">
        {problems.map(p => <li key={p.title} className="flex gap-4 rounded-2xl border border-forest/10 bg-white p-5 shadow-[0_4px_20px_rgba(9,40,29,0.06)] sm:p-6" data-id="element-145" data-mp="2o3yiztuc6iy7">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-50 text-red-600" data-id="element-146" data-mp="2f53auc7qeys9">
              <XIcon className="h-5 w-5" aria-hidden data-id="element-147" data-mp="hdsd2bu9qciv" />
            </span>
            <div data-id="element-148" data-mp="dcowto8b6eh4">
              <h3 className="font-display text-2xl font-bold uppercase leading-tight text-forest" data-id="element-149" data-mp="de9rreyjbzfi">{p.title}</h3>
              <p className="mt-1 text-forest/75" data-id="element-150" data-mp="34q3g1xzoe15a">{p.desc}</p>
            </div>
          </li>)}
      </ul>
      <p className="mx-auto mt-10 max-w-2xl text-center font-display text-2xl font-bold uppercase text-forest sm:mt-14 sm:text-3xl" data-id="element-151" data-mp="39rj0poxxy5n5">
        Combien de cours allez-vous encore <span className="text-golddark" data-id="element-152" data-mp="2zr0beenlxwxu">préparer de zéro ?</span>
      </p>
    </section>;
}